export default __webpack_public_path__ + "static/media/018_photo.25812dd9.jpg";